module.exports = __webpack_public_path__ + "img/check.25473b83.png";